(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventsSummary",
                    {
                        url: "/Summary/:SummaryYear",
                        component: "summaryNew",
                        PageTitle: "Events Summary | Marketing Tracker",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }],
                            eventTypes: function () {
                                return {
                                    Cumulative: {
                                        name: "Cumulative",
                                        identifier: "All",
                                        url: "^.Cumulative",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.Cumulative",
                                        types: []
                                    },
                                    ClientEvents: {
                                        name: "Client Events",
                                        identifier: "ClientEvents",
                                        url: "^.ClientEvents",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.ClientEvents",
                                        types: ["All", "Client Appreciation Events", "Client Educational Events", "Social Events", "Holiday Events", "Referral Events"],
                                        aumColor: "#86c8e4",
                                        insuranceColor: "#0f89bf"
                                    },
                                    CollegeClasses: {
                                        name: "College Classes",
                                        identifier: "CollegeClasses",
                                        url: "^.CollegeClasses",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.CollegeClasses",
                                        types: ["All", "College Courses", "College Courses - Power of Zero"],
                                        aumColor: "#fbbc71",
                                        insuranceColor: "#ea8c1c"
                                    },
                                    DinnerSeminars: {
                                        name: "Dinner Seminars",
                                        identifier: "DinnerSeminars",
                                        url: "^.DinnerSeminars",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.DinnerSeminars",
                                        types: ["All", "Dinner Seminars"],
                                        aumColor: "#b9aae1",
                                        insuranceColor: "#9b7ce7"
                                    },
                                    SSSeminars: {
                                        name: "Social Security Seminars",
                                        identifier: "SSSeminars",
                                        url: "^.SSSeminars",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.SSSeminars",
                                        types: ["All", "Social Security Seminars"],
                                        aumColor: "#f0cce6",
                                        insuranceColor: "#d570b8"
                                    },
                                    PEWorkshops: {
                                        name: "Public Educational Workshops",
                                        identifier: "PEWorkshops",
                                        url: "^.PEWorkshops",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.PEWorkshops",
                                        types: ["All", "Public Edu Workshops"],
                                        aumColor: "#94e1af",
                                        insuranceColor: "#0f9f41"
                                    },
                                    Referrals: {
                                        name: "Referrals",
                                        identifier: "Referrals",
                                        url: "^.Referrals",
                                        sRef: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.Referrals",
                                        types: ["All", "Referral Events"],
                                        aumColor: "#efdd6b",
                                        insuranceColor: "#dfc30d"
                                    }
                                };
                            }
                        },
                        redirectTo: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.Cumulative"
                    });
        }
    ]);

    app
        .component("summaryNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventsSummary/summary-new-template.html",
                controller: summaryNewController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<",
                    eventTypes: "<"
                }
            });

    summaryNewController.$inject = ["$scope", "$state", "marketingTrackerEventGroupApi", "_", "moment", "$filter"];

    function summaryNewController($scope, $state, marketingTrackerEventGroupApi, _, moment, $filter) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                broadcast: broadcast,
                getUserEvents: getUserEvents,
                getUserEventExport: getUserEventExport,
                getEventsByType: getEventsByType,
                getDoughnuts: getDoughnuts,
                goToState: goToState,
                goToYear: goToYear,
                goToTotalType: goToTotalType,
                totalTypes: ["TotalAssetsClosed", "TotalInsuranceBusinessClosed", "TotalAumBusinessClosed", "TotalCommission", "TotalEventCost"],
                years: [],
                ui: {}
            });

        function getDateRange() {

            var today = new Date();

            // determine end date
            var endDate = new Date($ctrl.summaryYear + 1, 0, 1).toISOString();
            if ($ctrl.summaryYear === today.getFullYear()) {
                endDate = new Date();
            }

            return {
                startDate: moment(new Date($ctrl.summaryYear, 0, 1)).toISOString(),
                endDate: moment(endDate).toISOString()
            };
        };

        function getEventsByType(figAuthUserId, eventTypes) {
            var range = getDateRange();
            return getUserEventsByDate(figAuthUserId, eventTypes, range.startDate, range.endDate);
        };

        function getUserEvents(figAuthUserId) {
            var eventTypes = [];
            if ($ctrl.ui.selectedEventType === "All")
                eventTypes = $filter("filter")($ctrl.ui.eventTypeOptions, "!All");
            else
                eventTypes = [
                    $ctrl.ui.selectedEventType
                ];

            var range = getDateRange();
            return getUserEventsByDate(figAuthUserId, eventTypes, range.startDate, range.endDate);
        }

        function getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, nextPageToken) {
            return marketingTrackerEventGroupApi
                .getUserEventGroupsByDate(eventTypes, startDate, endDate, nextPageToken).then(
                    function (events) {

                        if (!events.NextPage)
                            return events;

                        return getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, events.NextPage).then(
                            function (recursiveEvents) {
                                return events = _.concat(events, recursiveEvents);
                            });
                    });
        }

        function getUserEventExport(figAuthUserId) {
            var eventTypes = [];
            if ($ctrl.ui.selectedEventType === "All")
                eventTypes = $filter("filter")($ctrl.ui.eventTypeOptions, "!All");
            else
                eventTypes = [
                    $ctrl.ui.selectedEventType
                ];

            var range = getDateRange();
            return marketingTrackerEventGroupApi
                .downloadUserEventGroupsByDate(eventTypes, range.startDate, range.endDate);
        }

        function getDoughnuts(num) {
            if (num < 0) return [0, 100];
            return [num, num < 100 ? 100 - num : 0];
        }

        function goToState(state) {
            $ctrl.selectedState = state;
            $ctrl.ui.eventTypeOptions = $ctrl.selectedState.types;
            $ctrl.ui.selectedEventType = $ctrl.ui.eventTypeOptions.length > 2 ? $ctrl.ui.eventTypeOptions[0] : $ctrl.ui.eventTypeOptions[1];
            $state.go(state.url);
        }

        function goToTotalType(totalType, eventType) {

            return $state.go("Home.Tools.MarketingTrackerNew.Events.EventsSummary.Cumulative.TotalsView",
                { TotalType: totalType, SummaryYear: $ctrl.summaryYear, EventType: eventType });
        }

        function goToYear() {
            var params = ng.copy($state.params);
            params.SummaryYear = $ctrl.summaryYear;
            var currentState = $state.current.name;
            $state.go(currentState, params);
        }

        function broadcast(broadcastEvent, broadcastProperty, broadcast) {
            var broadcastContainer = {};
            broadcastContainer[broadcastProperty] = broadcast;
            $scope.$broadcast(broadcastEvent, broadcastContainer);
        }

        $scope.$on('selectedTotalTypeChange', function (event, data) {
            $ctrl.selectedTotalType = data.selectedTotalType;
        });

        $ctrl.$onInit = function () {
            $ctrl.currentYear = (new Date()).getUTCFullYear();
            for (var i = 2015; i <= $ctrl.currentYear; i++) {
                $ctrl.years.push(i);
            }
            $ctrl.summaryYear = parseInt($state.params.SummaryYear);
            if ($state.params.TotalType) {
                $ctrl.selectedTotalType = $state.params.TotalType;
            }
            if ($state.params.EventType) {
                $ctrl.eventType = $state.params.EventType;
            }

            $ctrl.selectedState = _.find($ctrl.eventTypes, function (t) {

                //todo: remove below when CumulativeOld page is removed...this is just to 
                //make the page still work when going directly to it in case we might need to revert
                if ($state.$current.name.split(".", 6)[5] === "CumulativeOld") return "Cumulative";

                return t.url.split(".", 2)[1] === $state.$current.name.split(".", 6)[5];
            });
            $ctrl.ui.eventTypeOptions = $ctrl.selectedState.types;
            $ctrl.ui.selectedEventType = $ctrl.ui.eventTypeOptions.length > 2 ? $ctrl.ui.eventTypeOptions[0] : $ctrl.ui.eventTypeOptions[1];
        };

    }

})(window.app, window.angular); //jshint ignore:line